/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed

import type { ConcreteRequest } from 'relay-runtime';
export type OnboardingStateInput = {
  key: string;
  value: string;
};
export type onboardingStateSetOnboardingStateMutation$variables = {
  states: ReadonlyArray<OnboardingStateInput>;
};
export type onboardingStateSetOnboardingStateMutation$data = {
  readonly setOnboardingState: ReadonlyArray<{
    readonly key: string;
    readonly value: string | null;
  }> | null;
};
export type onboardingStateSetOnboardingStateMutation = {
  response: onboardingStateSetOnboardingStateMutation$data;
  variables: onboardingStateSetOnboardingStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "states"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "states",
        "variableName": "states"
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "setOnboardingState",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "onboardingStateSetOnboardingStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onboardingStateSetOnboardingStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3faa5f50f8c511a1bae008881ee58062",
    "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
    "metadata": {},
    "name": "onboardingStateSetOnboardingStateMutation",
    "operationKind": "mutation",
    "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
  }
};
})();

(node as any).hash = "90b0af82da00eefb44f28228419e7c9e";

export default node;
